require('initializers/gettext').default(__TRANSLATIONS__.gettext['nl-BE']); // eslint-disable-line no-undef
require('initializers/i18n').default('nl-BE', __TRANSLATIONS__.i18n['nl-BE']); // eslint-disable-line no-undef

require('locales/dependencies');

require('select2/dist/js/i18n/nl');
require('jquery-ui/ui/i18n/datepicker-nl-BE');
require('moment/locale/nl-be');
require('dayjs/locale/nl-be');
